namespace Matrix.Workflow {
    export interface ClientFunctionInvocationRow {
        InvocationId?: number;
        FunctionName?: string;
        Parameters?: string;
        StatusCode?: string;
        StartedWhen?: string;
        FinishedWhen?: string;
        DurationMs?: number;
        StdOut?: string;
        StdErr?: string;
        WorkflowInstanceId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        FunctionDescription?: string;
        FunctionEnabled?: boolean;
        FunctionRunnable?: boolean;
        FunctionRerunnable?: boolean;
        FunctionRowId?: number;
        StatusDescription?: string;
        StatusRowId?: number;
        WorkflowInstanceCorrelationId?: string;
        WorkflowInstanceCreatedDate?: string;
        WorkflowInstanceWorkflowCode?: string;
        WorkflowInstanceStatusCode?: string;
        WorkflowInstanceTriggerCode?: string;
        WorkflowInstanceStartedWhen?: string;
        WorkflowInstanceFinishedWhen?: string;
        WorkflowInstanceDurationMs?: number;
        WorkflowInstanceStdOut?: string;
        WorkflowInstanceStdErr?: string;
        WorkflowInstanceProperties?: string;
        WorkflowInstanceKey1?: string;
        WorkflowInstanceKey2?: string;
        WorkflowInstanceKey3?: string;
        WorkflowInstanceKey4?: string;
        WorkflowInstanceKey5?: string;
        WorkflowInstanceRowId?: number;
    }

    export namespace ClientFunctionInvocationRow {
        export const idProperty = 'InvocationId';
        export const nameProperty = 'FunctionName';
        export const localTextPrefix = 'Workflow.ClientFunctionInvocation';
        export const deletePermission = 'DataAdmin:ClientFunctionInvocation';
        export const insertPermission = 'DataAdmin:ClientFunctionInvocation';
        export const readPermission = 'Read:ClientFunctionInvocation';
        export const updatePermission = 'DataAdmin:ClientFunctionInvocation';

        export declare const enum Fields {
            InvocationId = "InvocationId",
            FunctionName = "FunctionName",
            Parameters = "Parameters",
            StatusCode = "StatusCode",
            StartedWhen = "StartedWhen",
            FinishedWhen = "FinishedWhen",
            DurationMs = "DurationMs",
            StdOut = "StdOut",
            StdErr = "StdErr",
            WorkflowInstanceId = "WorkflowInstanceId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            FunctionDescription = "FunctionDescription",
            FunctionEnabled = "FunctionEnabled",
            FunctionRunnable = "FunctionRunnable",
            FunctionRerunnable = "FunctionRerunnable",
            FunctionRowId = "FunctionRowId",
            StatusDescription = "StatusDescription",
            StatusRowId = "StatusRowId",
            WorkflowInstanceCorrelationId = "WorkflowInstanceCorrelationId",
            WorkflowInstanceCreatedDate = "WorkflowInstanceCreatedDate",
            WorkflowInstanceWorkflowCode = "WorkflowInstanceWorkflowCode",
            WorkflowInstanceStatusCode = "WorkflowInstanceStatusCode",
            WorkflowInstanceTriggerCode = "WorkflowInstanceTriggerCode",
            WorkflowInstanceStartedWhen = "WorkflowInstanceStartedWhen",
            WorkflowInstanceFinishedWhen = "WorkflowInstanceFinishedWhen",
            WorkflowInstanceDurationMs = "WorkflowInstanceDurationMs",
            WorkflowInstanceStdOut = "WorkflowInstanceStdOut",
            WorkflowInstanceStdErr = "WorkflowInstanceStdErr",
            WorkflowInstanceProperties = "WorkflowInstanceProperties",
            WorkflowInstanceKey1 = "WorkflowInstanceKey1",
            WorkflowInstanceKey2 = "WorkflowInstanceKey2",
            WorkflowInstanceKey3 = "WorkflowInstanceKey3",
            WorkflowInstanceKey4 = "WorkflowInstanceKey4",
            WorkflowInstanceKey5 = "WorkflowInstanceKey5",
            WorkflowInstanceRowId = "WorkflowInstanceRowId"
        }
    }
}
